import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import EmojiParsed from './EmojiParsed';

const propTypes = {
  text: PropTypes.string,
  trim: PropTypes.bool,
  br: PropTypes.bool,
  parseEmojis: PropTypes.bool,
};

const AutoP = ({ text = '', trim, br, parseEmojis }) => {
  if (!text || text.trim() === '') {
    return '';
  }

  // Split up the contents into an array of strings, separated by double line breaks.
  const textFragments = text
    .split(/\n\s*\n/)
    .filter(Boolean)
    .map(s => (trim ? s.trim() : s));

  return textFragments.map((textFragment, index) => {
    if (br) {
      // Optionally insert line breaks for textFragments that contain single line breaks.
      const innerTextFragments = textFragment.split('\n');
      const innerTextContent = innerTextFragments.map(
        (innerTextFragment, innerTextFragmentIndex, array) => {
          const val = trim ? innerTextFragment.trim() : innerTextFragment;
          return (
            <Fragment key={innerTextFragmentIndex}>
              {parseEmojis ? <EmojiParsed text={val} /> : val}
              {
                // Don't append a <br /> on the very last textFragment
                array.length > innerTextFragmentIndex + 1 && <br />
              }
            </Fragment>
          );
        },
      );

      return <p key={index}>{innerTextContent}</p>;
    }

    return (
      <p key={index}>
        {parseEmojis ? <EmojiParsed text={textFragment} /> : textFragment}
      </p>
    );
  });
};

AutoP.propTypes = propTypes;

export default AutoP;
